// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import CustomerClient from '@/api/customer/customer-client';
const customerClient = new CustomerClient();
export default {
    createCustomer: async function (context, payload) {
        var result = await customerClient.postAsync({
            url: `${customerClient.url}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    updateCustomer: async function (context, payload) {
        var result = await customerClient.putAsync({
            url: `${customerClient.url}/${payload.id}`,
            data: payload
        }, true);
        if (result) {
            return result;
        }
        return null;
    },

    deleteCustomer: async function (context, payload) {
        var result = await customerClient.deleteAsync({
            url: `${customerClient.url}/${payload.id}/delete`,
            queries: payload,
        }, true);
        return result;
    },


    getCustomer: async function (context, payload) {
        var result = await customerClient.getAsync({
            url: `${customerClient.url}/${payload.id}/detail`,
        }, true);
        if (result && result.data) {
            context.commit("updateCustomer", result.data);
            return result.data;
        }
        return null;
    },

    getCustomers: async function (context, payload) {
        var result = await customerClient.getAsync({
            url: `${customerClient.url}/search`,
            queries: payload
        }, true);
        if (result && result.data) {
            context.commit('updateTotalPage', result.data);
            return result.data;
        }
        return null;
    },

    getCustomerList: async function (context, payload) {
        var result = await customerClient.getAsync({
            url: `${customerClient.url}/search`,
            queries: payload
        }, true);
        if (result && result.data) {
            context.commit("updateCustomers", result.data.rows);
            return result.data.rows;
        }
        return [];
    },
}